import dayjs from 'dayjs';
import { OnePagerContext } from './context';
import { OnePagerSectionConfig } from '../editor/dealSummaryEditorInitializer';
import {
    DATA_NOT_AVAILABLE_HIGHLIGHT as YELLOW,
    DATA_NOT_AVAILABLE_LABEL as DataNotAvl,
    DEFAULT_TWO_COL_1_2_SIZES,
} from '../editor/dealSummaryEditorConstants';
import { bullet, h2, spacer, table, td, text, TextNode, tr, TrRow } from './plateNodes';

export function buildManagementProfileSection(ctx: OnePagerContext, section: OnePagerSectionConfig): any[] | null {
    const { ai_profile_main_data } = ctx;

    const directors: any[] = ai_profile_main_data?.directors ?? [];

    const rows: TrRow[] = directors.length
        ? directors.map((director: any) =>
              tr([
                  td(director?.name ?? ''),
                  td(
                      bullet([
                          [
                              text(`Designation: `, { bold: true }),
                              director?.designation
                                  ? text(`${director?.designation ?? ''}`)
                                  : text(DataNotAvl, { backgroundColor: YELLOW, bold: true }),
                          ],
                          [
                              text(`Director Since:`, { bold: true }),
                              director?.tenureBeginDate
                                  ? text(` ${dayjs(director?.tenureBeginDate).format('MMM YYYY')}`)
                                  : text(DataNotAvl, { backgroundColor: YELLOW, bold: true }),
                          ],
                          [
                              text(`Age:`, { bold: true }),
                              director?.age ? text(` ${director?.age ?? ''}`) : text(DataNotAvl, { backgroundColor: YELLOW, bold: true }),
                          ],
                      ]),
                  ),
              ]),
          )
        : [
              tr([
                  td([text(DataNotAvl, { backgroundColor: YELLOW })] as TextNode[]),
                  td([text(DataNotAvl, { backgroundColor: YELLOW })] as TextNode[]),
              ]),
          ];

    return [h2([text(section.label)]), table(rows, { colSizes: DEFAULT_TWO_COL_1_2_SIZES }), spacer()];
}
